import React from 'react';
import ReactLoadingSkeleton from 'react-loading-skeleton';

// This enables skeleton to respect the parent's line height / fontsize e.g. Typography wrapping a Skeleton
const defaultStyle = { lineHeight: 'inherit' };

export default function Skeleton({
  style = defaultStyle,
  borderRadius = '0.25rem',
  ...props
}) {
  return <ReactLoadingSkeleton style={{ ...style, borderRadius }} {...props} />;
}
